module.exports = __webpack_public_path__ + "img/礼物.8dac7597.png";